import "./App.css";
import { useEffect } from "react";
import faviconUrl from "@/assets/branding/favicon.svg";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import HowItWorks from "./pages/HowItWorks";
import BecomeWorker from "./pages/BecomeWorker";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refunds from "./pages/Refunds";

import Cookies from "./pages/Cookies";
import LegalPolicy from "./pages/LegalPolicy";

// mobile legal pages
import AboutCustomer from "./pages/mobile-legal/about/AboutCustomer";
import AboutWorker from "./pages/mobile-legal/about/AboutWorker";
import CustomerCookiesPolicy from "./pages/mobile-legal/cookies-policy/CustomerCookiesPolicy";
import WorkerCookiesPolicy from "./pages/mobile-legal/cookies-policy/WorkerCookiesPolicy";
import CustomerPrivacyPolicy from "./pages/mobile-legal/privacy-policy/CustomerPrivacyPolicy";
import CustomerRefundPolicy from "./pages/mobile-legal/refund-policy/CustomerRefundPolicy";
import WorkerRefundPolicy from "./pages/mobile-legal/refund-policy/WorkerRefundPolicy";
import CustomerTermsAndConditions from "./pages/mobile-legal/terms-and-conditions/CustomerTermsAndConditions";
import WorkerTermsAndConditions from "./pages/mobile-legal/terms-and-conditions/WorkerTermsAndConditions";
import WorkerPrivacyPolicy from "./pages/mobile-legal/privacy-policy/WorkerPrivacyPolicy";

function App() {
  useEffect(() => {
    const existing = document.querySelector("link[rel='icon']");
    const link = existing || document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg+xml";
    link.href = faviconUrl;
    if (!existing) {
      document.head.appendChild(link);
    }
  }, []);
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/become-worker" element={<BecomeWorker />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund-policy" element={<Refunds />} />
        <Route path="/cookie-policy" element={<Cookies />} />
        <Route path="/legal/:slug" element={<LegalPolicy />} />

        {/* for mobile legal pages */}
        <Route path="/mobile/customer-privacy-policy" element={<CustomerPrivacyPolicy />} />
        <Route path="/mobile/worker-privacy-policy" element={<WorkerPrivacyPolicy />} />
        <Route path="/mobile/customer-terms-and-conditions" element={<CustomerTermsAndConditions />} />
        <Route path="/mobile/worker-terms-and-conditions" element={<WorkerTermsAndConditions />} />
        <Route path="/mobile/customer-refund-policy" element={<CustomerRefundPolicy />} />
        <Route path="/mobile/worker-refund-policy" element={<WorkerRefundPolicy />} />
        <Route path="/mobile/customer-cookies-policy" element={<CustomerCookiesPolicy />} />
        <Route path="/mobile/worker-cookies-policy" element={<WorkerCookiesPolicy />} />
        <Route path="/mobile/about-customer" element={<AboutCustomer />} />
        <Route path="/mobile/about-worker" element={<AboutWorker />} />
      </Routes>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
